import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';

import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';

import type { LayoutProps } from './layout-types';

const styles = cssMap({
	columnStyles: {
		flexGrow: 1,
		flexShrink: 0,
		flexBasis: '50%',
		minWidth: '0px',
		maxWidth: '360px',
	},
});

const REQUIRED_ELEMENTS_COUNT = 1;

export const TwoColumnLayout = ({ elements, key, isFoldable = false }: LayoutProps): React.JSX.Element | null => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return (
		<Inline space="space.200" grow="fill">
			<Box xcss={styles.columnStyles}>
				{elements.map(
					(element, index) =>
						typeof element !== 'string' &&
						(element.attributes?.pos === 'left' || (index === 0 && !element.attributes?.pos)) && (
							<DynamicLayoutComponent
								component={element}
								position="two-columns-left"
								key={`${key}-${element.attributes?.pos || index}`}
								isFoldable={isFoldable}
							/>
						),
				)}
			</Box>
			<Box xcss={styles.columnStyles}>
				{elements.map(
					(element, index) =>
						typeof element !== 'string' &&
						(element.attributes?.pos === 'right' || (index === 1 && !element.attributes?.pos)) && (
							<DynamicLayoutComponent
								component={element}
								position="two-columns-right"
								key={`${key}-${element.attributes?.pos || index}`}
								isFoldable={isFoldable}
							/>
						),
				)}
			</Box>
		</Inline>
	);
};
